import { ENDPOINTS } from "Config/endpoints"
import protectedApi from "Config/protectedApi"

export const getBlogCategoryFn = () => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.blog_category_api}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBlogCategoryByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.blog_category_api}?category_id=${id}`);
    return response;
}

export const postBlogCategoryFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.blog_category_api}`, reqBody);
    return response;
}

export const patchBlogCategoryFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.blog_category_api}`, reqBody);
    return response;
}

export const deleteBlogCategoryFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.blog_category_api}`, { data: reqBody });
    return response;
}

export const getBlogSubCategoryFn = () => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.blog_sub_category_api}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBlogSubCategoryByCategoryIdFn = (category_id) => {
    const response = protectedApi.get(`${ENDPOINTS.blog_sub_category_api}?category=${category_id}`);
    return response;
}

export const getBlogSubCategoryByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.blog_sub_category_api}?subcategory_id=${id}`);
    return response;
}

export const postBlogSubCategoryFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.blog_sub_category_api}`, reqBody);
    return response;
}

export const patchBlogSubCategoryFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.blog_sub_category_api}`, reqBody);
    return response;
}

export const deleteBlogSubCategoryFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.blog_sub_category_api}`, { data: reqBody });
    return response;
}

export const getBlogFn = () => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.blog_api}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBlogByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.blog_api}?blog_id=${id}`);
    return response;
}

export const postBlogFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.blog_api}`, reqBody);
    return response;
}

export const patchBlogFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.blog_api}`, reqBody);
    return response;
}

export const deleteBlogFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.blog_api}`, { data: reqBody });
    return response;
}

